if (!customElements.get('rival-vehicle-browser')) {
  customElements.define('rival-vehicle-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const cards = [...this.querySelectorAll('.rival-vehicles__item')];
      const families = [...new Set(cards.map(card => card.querySelector('[data-vehicle-family]')?.dataset.vehicleFamily).filter(Boolean))];
      const familyOrder = {
        ford: ['Fiesta', 'Focus', 'Puma', 'Mustang', 'Ranger'],
        bmw: ['1 Series', '2 Series', '3 Series', '4 Series', 'M', 'X', 'Z Series'],
        audi: ['A', 'S', 'RS', 'TT', 'R8']
      }[this.dataset.make] || [];
      const rank = family => family === 'Other' ? Number.MAX_SAFE_INTEGER : familyOrder.includes(family) ? familyOrder.indexOf(family) : familyOrder.length;
      families.sort((a, b) => rank(a) - rank(b) || a.localeCompare(b, undefined, { numeric: true }));
      if (cards.length < 6 || families.length < 2) return;
      const filters = this.querySelector('.rival-vehicles__filters');
      const count = this.querySelector('.rival-vehicles__count');
      const key = `rival-vehicle-family:${this.dataset.make}`;
      filters.setAttribute('role', 'group');
      filters.setAttribute('aria-label', this.dataset.filterLabel);
      const buttons = ['', ...families].map(family => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rival-vehicles__filter';
        button.textContent = family || this.dataset.allLabel;
        button.dataset.family = family;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => select(family));
        filters.append(button);
        return button;
      });
      const select = family => {
        let visible = 0;
        cards.forEach(card => {
          card.hidden = Boolean(family && card.querySelector('[data-vehicle-family]')?.dataset.vehicleFamily !== family);
          if (!card.hidden) visible += 1;
        });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.family === family)));
        count.textContent = `${visible} ${visible === 1 ? 'model' : 'models'}`;
        count.setAttribute('aria-label', `${visible} of ${cards.length} models`);
        try { sessionStorage.setItem(key, family); } catch (_) {}
      };
      let saved = '';
      try { saved = sessionStorage.getItem(key) || ''; } catch (_) {}
      select(families.includes(saved) ? saved : '');
      filters.hidden = false;
      count.hidden = false;
    }
  });
}
